import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Products from './components/Products';
 
function App() {
  return (
    <div className="App">
      <Navbar/>
      <Products/>
      <Footer/>
    </div>
  );
}

export default App;
